module.exports = __webpack_public_path__ + "img/8-r.ff8ec466.png";